export const TEMP_PASSWORD_EXPIRED_MESSAGE =
  'Temporary password has expired and must be reset by an administrator.';
